<template>
  <b-row>
    <b-col cols="12">
      <time-line type="simple" v-if="!reloadPlan">
        <template v-for="(item, itemIndex) in dailyPlanItems">
          <time-line-item v-show="item.status !== 2" inverted badge-type="secondary" badge-icon="nc-icon nc-briefcase-24" v-bind:key="'dailyPlanItem-' + itemIndex">
            <div slot="header" variant="success">
              <template v-if="item.status === 1">
                <b-badge v-if="item.task.finished === 1" variant="success">{{ $t('global.over')}}</b-badge>
                <b-badge v-else-if="item.task.finished === 0 && item.task.started === 1" variant="warning">{{ $t('global.processing')}}</b-badge>
                <b-badge v-else-if="item.task.finished === 0 && item.task.started === 0" variant="danger">{{ $t('global.notStarted')}}</b-badge>
              </template>
              <template v-else-if="item.status === 0">
                <b-badge variant="danger">{{ $t('global.held')}}</b-badge>
              </template>
              <template v-else-if="item.status === 2">
                <b-badge v-if="item.dateStart && item.dateStop" variant="warning">{{ $t('global.movedStarted')}}</b-badge>
                <b-badge v-else variant="warning">{{ $t('global.movedNotStarted')}}</b-badge>
              </template>
              <template v-else-if="item.status === 3">
                <b-badge v-if="item.dateStart && item.dateStop" variant="warning">{{ $t('global.movedToMainStarted')}}</b-badge>
                <b-badge v-else variant="warning">{{ $t('global.movedToMainNotStarted')}}</b-badge>
              </template>
              <div class="float-right" v-if="item.confirmed == 0 && isServiceman">
                <b-row>
                  <b-col cols="12" class="m-0">
                    <b-btn v-if="itemIndex !== 0" class="float-right mb-1" @click="moveUp(itemIndex)" size="sm"><i class="fas fa-sort-up"></i></b-btn>
                  </b-col>
                  <b-col cols="12" class="m-0">
                    <b-btn v-if="(itemIndex + 1) !== dailyPlanItems.length" class="float-right mt-1" @click="moveDown(itemIndex)" size="sm"><i class="fas fa-sort-down"></i></b-btn>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div slot="content">
              <h5>
                <router-link
                  :to="{name: 'EXCMTaskShow', params: { id: item.task['@id'] }}">
                  {{ item.durationText }} (<span v-if="item.dateStart">{{ $moment(item.dateStart).format('HH:mm:ss') }}</span><span v-else>00:00</span> - <span v-if="item.dateStop">{{ $moment(item.dateStop).format('HH:mm:ss') }}</span><span v-else>00:00</span>)
                </router-link>
              </h5>
              <h6>
                <router-link
                  :to="{name: 'EXCMCaseShow', params: { id: item.task.idCase['@id'] }}">
                  {{ $t('global.case') }}
                  <span v-if="item.task.idCase.number">#{{item.task.idCase.number}}</span>
                  <span v-else>#{{getIdLink(item.task.idCase['@id'])}}</span>
                </router-link>
              </h6>
              <small>
                {{ item.task.idCase.caseType.title }} | {{ item.task.idTaskType.title }}
              </small>
              <p v-if="item.task.idCase.idDevice">{{ item.task.idCase.idDevice.idDeviceModel.idDeviceBrand.brandTitle }} {{ item.task.idCase.idDevice.idDeviceModel.model }} ({{ item.task.idCase.idDevice.serialNumber }})</p>
            </div>
            <div slot="footer">
              <template v-if="!isItemMoved(item['@id'])">
                <b-btn
                  block
                  v-if="item.task.finished === 0 && item.task.started === 1 && item.status === 1"
                  size="sm"
                  @click="holdTask(item)"
                  class="mt-1">
                  {{ $t('buttons.hold') }}
                </b-btn>
                <template v-if="!isServiceman">
                  <b-btn
                    block
                    v-if="item.task.finished === 0 && item.status === 1"
                    size="sm"
                    @click="finishTaskManually(item.task)"
                    class="mt-1">
                    {{ $t('buttons.stop') }}
                  </b-btn>
                  <b-btn
                    block
                    v-if="item.task.started === 0 && item.task.finished === 0 && item.status < 2"
                    size="sm" class="mt-1"
                    @click="moveDailyPlanItem(item)">
                    {{ $t('buttons.move') }}
                  </b-btn>
                  <b-btn
                    block
                    v-if="item.task.started === 0 && item.task.finished === 0 && item.status < 2"
                    size="sm"
                    @click="handleTaskOperation(item.task['@id'],'return')"
                    class="mt-1">
                    {{ $t('buttons.returnTask') }}
                  </b-btn>
                </template>
                <template v-else>
                  <b-btn
                    block
                    v-if="item.task.finished === 0 && item.task.started === 0 && item.status === 1"
                    size="sm"
                    @click="handleTaskOperation(item.task['@id'], 'start')"
                    class="mt-1">
                    {{ $t('buttons.start') }}
                  </b-btn>
                  <b-btn
                    v-else-if="item.task.finished === 0 && item.task.started === 1"
                    block
                    size="sm"
                    @click="handleTaskOperation(item.task['@id'],'finish')"
                    class="mt-1">
                    {{ $t('buttons.stop') }}
                  </b-btn>
                </template>
              </template>
            </div>
          </time-line-item>
        </template>
      </time-line>
      <TaskCloseManuallyModal></TaskCloseManuallyModal>
<!--      <CreateEXCMTaskModal></CreateEXCMTaskModal>-->
    </b-col>
  </b-row>
</template>

<script>
import TimeLine from 'src/components/UIComponents/TimeLine/TimeLine'
import TimeLineItem from 'src/components/UIComponents/TimeLine/TimeLineItem'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import TaskCloseManuallyModal from '../../../excmtask/components/TaskCloseManually/TaskCloseManuallyModal'
import ApiService from '@/utils/ApiService'

export default {
  name: 'ItemDailyPlanList',
  components: {
    // CreateEXCMTaskModal,
    TaskCloseManuallyModal,
    TimeLine,
    TimeLineItem
  },

  data () {
    return {
      map: null,
      reloadPlan: false,
      pushers: [],
      markers: []
    }
  },

  props: {
    dailyPlanItems: {
      type: Array,
      required: true
    }
  },

  computed: {
    isServiceman () {
      return getUserRoles().roles.includes('ROLE_SERVICEMAN') || getUserRoles().roles.includes('ROLE_EXTERNAL_SERVICEMAN') || getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    }
  },

  methods: {
    isItemMoved (id) {
      let moveReason = this.dailyPlanItems.find(task => task['@id'] === id).moveReason
      return moveReason ? true : moveReason === ''
    },

    async handleTaskOperation (link, operation) {
      let id = this.getIdLink(link)
      const response = await new ApiService(`e_x_c_m_tasks/${id}/${operation}`).put({})
      if (response.status === 200) {
        this.$emit('update')
      }
    },

    holdTaskAsServiceman (item) {
      this.$Swal({
        title: this.$t('views.excmdailyplan.create.heldTaskConfirmation'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then(async (result) => {
        if (result) {
          let id = this.getIdLink(item['@id'])
          const response = await new ApiService(`e_x_c_m_daily_plan_items/${id}/hold`).put()
          if (response.status === 200) {
            this.$emit('update')
          }
        }
      })
    },

    holdTaskAsAnotherUser (dailyPlanItem) {
      this.$store.state.modals.dailyplan.hold.show = 1
      this.$store.state.modals.dailyplan.hold.dailyPlanItemObject = dailyPlanItem
    },

    holdTask (dailyPlanItem) {
      if (this.isServiceman) {
        this.holdTaskAsServiceman(dailyPlanItem)
      } else {
        this.holdTaskAsAnotherUser(dailyPlanItem)
      }
    },

    moveDailyPlanItem (dailyPlanItem) {
      this.$store.state.modals.dailyplan.move.show = 1
      this.$store.state.modals.dailyplan.move.dailyPlanItemObject = dailyPlanItem
    },

    moveUp (index) {
      this.reloadPlan = true
      let dailyPlan = this.dailyPlanItems
      let lower = dailyPlan[index]
      let higher = dailyPlan[index - 1]
      dailyPlan[index] = higher
      dailyPlan[index - 1] = lower
      lower.customOrdering = lower.customOrdering - 1
      higher.customOrdering = higher.customOrdering + 1
      this.updateCustomOrder(dailyPlan[index - 1])
      this.updateCustomOrder(dailyPlan[index])
      this.dailyPlanItems = dailyPlan
      this.reloadPlan = false
    },

    moveDown (index) {
      this.reloadPlan = true
      let dailyPlan = this.dailyPlanItems
      let lower = dailyPlan[index + 1]
      let higher = dailyPlan[index]
      lower.customOrdering = lower.customOrdering - 1
      higher.customOrdering = higher.customOrdering + 1
      dailyPlan[index + 1] = higher
      dailyPlan[index] = lower
      this.updateCustomOrder(dailyPlan[index + 1])
      this.updateCustomOrder(dailyPlan[index])
      this.dailyPlanItems = dailyPlan
      this.reloadPlan = false
    },

    updateCustomOrder (item) {
      let id = this.getIdLink(item['@id'])
      let params = {
        customOrdering: item.customOrdering
      }
      this.$http
        .put('api/e_x_c_m_daily_plan_items/' + id,
          params
        )
        .then(response => {
          // this.$Swal({
          //   type: 'success',
          //   title: this.$t('notifications.operationDone'),
          //   timer: 2500
          // })
          this.$emit('update')
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    openCreateTaskModal (task) {
      this.$store.state.modals.excmtask.create.caseIri = task.idCase['@id']
      this.$store.state.modals.excmtask.create.show = 1
    },

    finishTaskManually (task) {
      this.$store.state.modals.excmtask.closeManually.show = 1
      this.$store.state.modals.excmtask.closeManually.dailyPlanItemDate = this.$route.params.date
      this.$store.state.modals.excmtask.closeManually.taskObject = Object.assign({}, task)
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
